// --- Adopted Road Filters ---

import z from "zod";
import { CheckboxFilterTypeSchema, MustMatchAllOrMatchNoneSchema } from "../common/common-filter-definitions-schema";
import { MUST_MATCH_ALL_FILTER } from "../common/filter-matchers";

export const AdoptedRoadTypeFilterSchema = z
  .object({
    id: z.literal("adopted-roads-type-id"),
    type: CheckboxFilterTypeSchema,
    must: MustMatchAllOrMatchNoneSchema,
    values: z.array(
      z.object({
        key: z.enum(["adopted", "prospective"]),
        checked: z.boolean(),
      }),
    ),
  })
  .describe("Types of adopted roads available");

export const AdoptedRoadDistanceFilterSchema = z
  .object({
    id: z.literal("adopted-roads-distance-id"),
    type: z.literal("number"),
    value: z.number().optional(),
  })
  .describe("Distance to closest adopted road in metres");

export const AdoptedRoadFilterSchema = z
  .object({
    id: z.literal("adopted-roads-id"),
    type: z.literal("compound"),
    must: z.literal(MUST_MATCH_ALL_FILTER),
    filters: z
      .array(z.union([AdoptedRoadTypeFilterSchema, AdoptedRoadDistanceFilterSchema]))
      .min(2)
      .max(2),
  })
  .describe("Filter for distance to adopted road by type");
